<template>
  <v-sheet tile color="white" class="fill-height">
    <v-container align="center">
      <v-row justify="center">
        <v-col cols="12" lg="4">
          <div class="title">Change Password</div>
          <br/>
          <div>
            <v-form v-model="isValid">
              <v-text-field filled outlined background-color="white" light required ref="password_field"
                            :rules="[v => !!v || 'Current Password is required']"
                            autocomplete="current-password"
                            :append-icon="show_current_pass? 'visibility' : 'visibility_off'" @input="resetError"
                            :type="show_current_pass? 'text': 'password'"
                            @click:append="show_current_pass = !show_current_pass"
                            v-model="current_password" label="Current password" name="current_password"/>

              <v-text-field filled outlined background-color="white" light required ref="password_field"
                            :rules="[v => !!v || 'New Password is required', v => v.length > 7 || 'Minimum password length is 8 chars']"
                            autocomplete="new-password"
                            :append-icon="show_new_pass? 'visibility' : 'visibility_off'" @input="resetError"
                            :type="show_new_pass? 'text': 'password'" @click:append="show_new_pass = !show_new_pass"
                            v-model="new_password" label="New password" name="new_password"/>
            </v-form>
          </div>
          <br/>
          <div align="center" class="error pa-2 rounded white--text" v-if="error">
            {{ error }}
          </div>
          <br/>
          <div align="right">
            <v-btn color="primary" :disabled="!isValid" @click="changePassword">Set New Password</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";
  import {AmplifyEventBus} from 'aws-amplify-vue';

  export default {
    name: "ChangePassword",
    data: () => {
      return {
        current_password: '',
        new_password: '',
        show_current_pass: false,
        show_new_pass: false,
        error: '',
        isValid: false
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'groupName'])
    },
    methods: {
      resetError() {
        this.error = ''
      },
      changePassword() {
        this.$Amplify.Auth.changePassword(
          this.currentUser,
          this.current_password,
          this.new_password
        ).then(() => {
          this.$Amplify.Auth.signOut()
            .then(() => {
              return AmplifyEventBus.$emit('authState', 'signedOut')
            })
        }).catch((response) => {
          this.error = response.message
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .error
  {
    color: #FE6868;
    background-color: transparent!important;
  }
</style>



// WEBPACK FOOTER //
// src/Pages/ChangePassword.vue